/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Coinvestments_Senddrafts_Autosave_Saved3Inputs */

const en_coinvestments_senddrafts_autosave_saved3 = /** @type {(inputs: Coinvestments_Senddrafts_Autosave_Saved3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saved ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Saved {time}" |
*
* @param {Coinvestments_Senddrafts_Autosave_Saved3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_autosave_saved3 = /** @type {((inputs: Coinvestments_Senddrafts_Autosave_Saved3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Autosave_Saved3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_autosave_saved3(inputs)
});
export { coinvestments_senddrafts_autosave_saved3 as "coInvestments_sendDrafts_autoSave_saved" }